// unique-prefix.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'uniquePrefix' })
export class UniquePrefixPipe implements PipeTransform {
  transform(value: string[], suffix: string): string[] {
    const seen = new Set<string>();
    const result: string[] = [];

    for (const val of value) {
      if (val.endsWith(suffix)) {
        const prefix = val.slice(0, -suffix.length); // remove o sufixo
        if (!seen.has(prefix)) {
          seen.add(prefix);
          result.push(prefix);
        }
      }
    }

    return result;
  }
}

